/** @module SiteAdmin/User/SkinTheme */
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
], function(declare,Enum) {

	return declare(Enum, {
		tagAction: "ActionChangeTheme",
		
		/**
		 * @override
		 * Action will be used for tooltip
		 */
		_getRenderAction: function(ctx, h) {
			var ad = this.inherited(arguments);
			if (ad) ad.bTooltip = true;
			
			return ad;
		}
	});
});